import styled from "styled-components";

export const AccountStyledWrapper = styled.div<{ $isMobile: boolean }>`
  margin-top: 20px;
  display: flex;
  justify-content: space-between;

  flex-direction: ${({ $isMobile }) => ($isMobile ? "column" : "row")};
`;
